import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import styles from './style.css';

// 逐字显示动画效果
const Verbatim = ({ content }) => {
    const [placeholder, setPlaceholder] = React.useState('');

    if (content) {
        const
            index = React.useRef(0);

        React.useEffect(() => {
            function tick() {
                setPlaceholder(prev => prev + content[index.current]);
                index.current++;
            }
            if (index.current < content.length) {
                let addChar = setInterval(tick, 30);
                return () => clearInterval(addChar);
            }
        }, [placeholder]);

        return (
            <div>
                {placeholder}
            </div>
        )
    } else {
        return (
            <div></div>
        )
    }
}

class StepCardLineText extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }


    render() {
        const { contentText, stepLast, cardLast } = this.props;

        return (
            <div>
                {
                    contentText.style ? (
                        <div className={styles.chatTextTitle}>{contentText.text}</div>
                    ) : (
                        stepLast && cardLast ? (
                            <div className={styles.chatText}>{<Verbatim content={contentText.text} />}</div>
                        ) : (
                            <div className={styles.chatText}>{contentText.text}</div>
                        )
                    )
                }
            </div>
        );
    }
}

export default StepCardLineText;
